const getPropertyByKeyPath = (path: string, object: {[index: string]:any} = {}): any => {
  const [...keys] = path.split('.');
  return keys.reduce((acc, key) => (acc && acc[key]) ? acc[key] : undefined, object);
}

export { getPropertyByKeyPath }